import { AlertTriangle } from 'react-feather';
import styles from './form-error-panel.module.scss';

export type FormErrorPanelProps = {
  message?: string;
};

export function FormErrorPanel({ message }: FormErrorPanelProps) {
  if (!message) return null;

  return (
    <div
      className={styles['error-panel']}
      role={'alert'}
      data-testid="form-error-panel"
    >
      <div className={styles['error-icon']} aria-hidden={'true'}>
        <AlertTriangle size={16} strokeWidth={2} />
      </div>
      <div className={styles['error-text']}>{message}</div>
    </div>
  );
}

export default FormErrorPanel;
